import dayjs from 'dayjs';
import { MatrialFilterFormValues, MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form/types';
import { MatrialTable } from 'features/master/components/table/matrial-table';
import { MatrialTopBar } from 'features/master/components/top-bar/matrial-top-bar';
import { useGetMatrialList } from 'features/master/use-cases/get-matrial';
import { usePaginationParams } from 'hooks';
import { omit } from 'lodash';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { formatDate } from 'utils/date';
const getInitialFilterValues: MatrialFilterFormValues = {
  date: [undefined, undefined],
  Title: undefined,
  phone_number: undefined,
  email: undefined,
  role: undefined,
  Type:undefined
};

const preparePayload = (params: MatrialFilterFormValuesPaginated) => {
  const createdAtFrom = params.date?.[0];
  const createdAtTo = params.date?.[1];

  return {
    ...omit(params, ['date']),
    created_at_from: createdAtFrom
      ? formatDate({
        date: dayjs(createdAtFrom).startOf('day'),
        format: 'dbDate',
      })
      : undefined,
    created_at_to: createdAtTo
      ? formatDate({
        date: dayjs(createdAtTo).endOf('day'),
        format: 'dbDate',
      })
      : undefined,
  };
};

export const MatrialView = () => {
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);

  const { params, updateParams, resetPage } =
    usePaginationParams<MatrialFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });

  const getmasterListQueryResponse: any = useGetMatrialList(preparePayload(params), {
    retry: false,
  });

  const handleFiltersChange = (values: MatrialFilterFormValuesPaginated) => {      
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <MatrialTopBar
        getInitialFilterValues={getInitialFilterValues}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
         onRefresh={getmasterListQueryResponse.refetch}
      />
      <MatrialTable
        ismasterListLoading={getmasterListQueryResponse.isFetching}
        masterList={getmasterListQueryResponse?.data?.rc}
        itemsCount={getmasterListQueryResponse.data?.totalRecords || 0}
        tableParams={params}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getmasterListQueryResponse.refetch}
        isFetching={ getmasterListQueryResponse.isFetching}
      />
      <Outlet />
    </>
  );
};
